/**
 * CCMS SDK configuration for the Rides portal.
 *
 *   browser → SDK fetch → Express proxy on :5183 → microservices
 *                         (or production via BACKEND_BASE_URL)
 *
 * The SDK's `baseUrl` points at the Express proxy (same pattern as ccms_v2 and
 * the Resource Centre). In production the Docker build sets it to `/api` and the
 * SPA's nginx forwards /api/* to the proxy container.
 */
export const CCMS_BASE_URL =
  import.meta.env.VITE_CCMS_BASE_URL
    ? import.meta.env.VITE_CCMS_BASE_URL
    : 'http://localhost:5183';

/** Gateway prefix of the Rides Management API (port 5046). */
export const CCMS_SERVICE_PATH_RIDES =
  import.meta.env.VITE_CCMS_SERVICE_PATH_RIDES ?? 'rides';

/** Public origin of this portal (notification deep links, share links). */
export const RIDES_PUBLIC_ORIGIN =
  import.meta.env.VITE_RIDES_PUBLIC_ORIGIN ?? (typeof window !== 'undefined' ? window.location.origin : '');
